import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@core/components/ui/alert";
import { Button } from "@core/components/ui/button";

interface PaymentBreakdownProps {
  payments: Record<string, number>;
  invoiceKeyById?: Record<number, string>;
  onClose: () => void;
}

export const PaymentBreakdown: React.FC<PaymentBreakdownProps> = ({
  payments,
  invoiceKeyById,
  onClose,
}) => {
  return (
    <div>
      <Alert variant="success" className="mb-4">
        <AlertTitle>Payment applied successfully</AlertTitle>
        <AlertDescription>
          Your payment was applied across the invoices below.
        </AlertDescription>
      </Alert>
      <div className="text-xl text-black shrink-0 mb-2">Payment Breakdown</div>
      <div className="flex-grow overflow-auto border rounded-sm border-gray-300">
        <table className="min-w-full text-left">
          <thead className="bg-gray-100 sticky top-0">
            <tr className="border-b border-gray-300">
              <th className="px-4 py-3 w-3/5">Invoice #</th>
              <th className="py-3 px-4 w-2/5 text-left">Amount Paid</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(payments).map(([invoiceId, amount]) => (
              <tr key={invoiceId} className="border-b border-gray-200">
                <td className="p-4">{invoiceKeyById?.[Number(invoiceId)] ?? `#${invoiceId}`}</td>
                <td className="p-4 flex w-2/5 text-left">
                  ${amount.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4 flex justify-end">
        <Button type="button" variant="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};
